export default __webpack_public_path__ + "static/media/Leggings of the Ravenflight.58e2a221.jpg";